module.exports = __webpack_public_path__ + "static/media/coin.ac7304d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/coin.png
// module id = 373
// module chunks = 0